export enum FasePublicacio {
  LICITACIO = "publicacionsLicitacio",
  ADJUDICACIO = "publicacionsAdjudicacio",
  FORMALITZACIO = "publicacionsFormalitzacio",
  FORMALITZACIO_MODIFICACIO = "publicacionsFormalitzacioModificacio",
  FORMALITZACIO_PRORROGA = "publicacionsFormalitzacioProrroga",
}
